import {
  CopilotChannelOptions,
  MaybeWindowWithCopilot,
  WindowWithCopilot,
} from '../types/Channel';
import {
  findNearestWindowWithCopilotChannel,
  findNearestWindowWithInstanceOfCopilotChannel,
} from '../utils/findNearestWindowWithCopilotChannel';
import CopilotChannel from './CopilotChannel';

export const createCopilotChannel = (options?: CopilotChannelOptions) => {
  const { instanceId } = options || {};

  // We're looking for an instance of a copilot channel on the window
  if (instanceId) {
    const topWindow = findNearestWindowWithInstanceOfCopilotChannel(
      window,
      instanceId
    );

    if (!topWindow.copilotChannelInstances) {
      topWindow.copilotChannelInstances = {};
    }

    if (!topWindow.copilotChannelInstances[instanceId]) {
      topWindow.copilotChannelInstances[instanceId] = new CopilotChannel(
        options
      );
    } else if (
      options?.createLayer !== undefined ||
      options?.__ENABLE_TEST_MODE !== undefined
    ) {
      // Instance already exists - options other than instanceId will be ignored
      console.error(
        `CopilotChannel instance "${instanceId}" already exists. ` +
          `Options passed to createCopilotChannel will be ignored. ` +
          `Existing instance will be returned.`
      );
    }

    return topWindow.copilotChannelInstances[instanceId];
  }

  const topWindow =
    options && options.createLayer
      ? (window as any as MaybeWindowWithCopilot)
      : findNearestWindowWithCopilotChannel(
          window as any as MaybeWindowWithCopilot
        );

  if (!topWindow.copilotChannel) {
    topWindow.copilotChannel = new CopilotChannel(options);
  }

  return (topWindow as WindowWithCopilot).copilotChannel;
};
